import { Spin } from 'components';
import React from 'react';

const Loading = () => {
  return (
    <div
      style={{
        zIndex: 999999,
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin />
    </div>
  );
};

export default Loading;
